<template>
    <div class="tournaments-view">
        <div v-if="!isMobile" class="tournaments-view__banner">
            <div class="banner-title">
                <span class="title-span">{{ $t("winWith") }}<br>
                    <h5 class="tournaments-word">{{ $t("tournaments") }}</h5>
                </span>
            </div>
            <div v-if="false" class="banner-text">
                <p><span class="special-text">{{ $t("thanksTo") }}</span><br>{{ $t("sponsorText") }}</p>
                <img class="partner-logo" src="https://hub.swiset.com/wp-content/uploads/2024/07/8ghtcap-logo.png"
                    alt="pft-logo.png">
            </div>
            <img class="banner-img" src="https://hub.swiset.com/wp-content/uploads/2024/08/Ilustraciones-torneos-03.png"
                alt="">
        </div>
        <section class="all-tournaments">
            <div class="tournaments-heading">
                <div class="tournaments-heading__items">
                    <h2>{{ $t("allTournaments") }}</h2>
                    <div class="tabs">
                        <input checked type="radio" id="active-option" name="tabs" value="actives"
                            v-model="atActiveTab" />
                        <label class="tab" for="active-option"><i class="fa-regular fa-hourglass-half" />{{
                            $t("tabs.active") }}</label>
                        <input type="radio" id="finished-option" name="tabs" value="finished" v-model="atActiveTab" />
                        <label class="tab" for="finished-option"><i class="fa-regular fa-flag-checkered"></i>{{
                            $t("tabs.finished") }}</label>
                        <span class="glider"></span>
                    </div>
                </div>
                <v-chip outlined @click="showAddTournament = true"><v-icon left>fa-regular fa-trophy</v-icon>{{
                    $t("createTournament") }}</v-chip>
            </div>
            <div class="all-tournaments__cards">
                <div class="cards-container-parent" @scroll="(e) => updateSliderControlsStatus(e.target)">
                    <div class="cards-container">
                        <TournamentCard v-for="(tournament) in atFilteredTournaments" :key="tournament.id"
                            cardType="allVariation"
                            :tournamentMsgState="getMessageStatus('ALL', tournament.enrolled, tournament.active, tournament.inProgress, tournament.lastUserRankingPlace, tournament.tournamentParticipanteStatus)"
                            :tournamentTitle="tournament.name" :tournamentStartDate="new Date(tournament.startTime)"
                            :tournamentEndDate="new Date(tournament.endTime)"
                            :tournamentInfo="[{ icon: 'fa-regular fa-calendar', text: getFormattedDate(new Date(tournament.startTime)) }, { icon: 'fa-regular fa-user', text: `${tournament.participantCount ? tournament.participantCount : ''} ${$t('tournamentInfo.participants')}` }, { icon: 'fa-regular fa-trophy', text: `${tournament.awardCount ? tournament.awardCount : ''} ${$t('tournamentInfo.prizes')}` }]"
                            :tournamentActive="tournament.active" :tournamentInProgress="tournament.inProgress"
                            :tournamentUserEnrolled="tournament.enrolled" :tournamentId="tournament.id">
                        </TournamentCard>
                    </div>
                </div>
                <h2 v-show="!atFilteredTournaments.length" class="all-tournaments__cards__noTournaments-paragraph">{{
                    $t("noActiveTournaments") }}</h2>
                <div class="slider-controls">
                    <button disabled @click="(e) => scrollContainer('at', false)" class="prev-btn">
                        <i class="fa-regular fa-chevron-left"></i>
                    </button>
                    <button disabled @click="(e) => scrollContainer('at', true)" class="next-btn">
                        <i class="fa-regular fa-chevron-right"></i>
                    </button>
                </div>
            </div>
        </section>
        <section class="my-tournaments">
            <div class="tournaments-heading">
                <div class="tournaments-heading__items">
                    <h2>{{ $t("myTournaments") }}</h2>
                    <div class="tabs">
                        <input checked type="radio" id="active-option-mt" name="tabs-mt" value="actives"
                            v-model="mtActiveTab" />
                        <label class="tab" for="active-option-mt"><i class="fa-regular fa-hourglass-half" />{{
                            $t("tabs.active") }}</label>
                        <input type="radio" id="finished-option-mt" name="tabs-mt" value="finished"
                            v-model="mtActiveTab" />
                        <label class="tab" for="finished-option-mt"><i class="fa-regular fa-hourglass-end"></i>{{
                            $t("tabs.finished") }}</label>
                        <span class="glider"></span>
                    </div>
                </div>
            </div>
            <div class="cards-container-parent" @scroll="(e) => updateSliderControlsStatus(e.target)">
                <div class="cards-container">
                    <TournamentCard v-for="(tournament) in mtFilteredTournaments" :key="tournament.id"
                        cardType="enrolledVariation"
                        :tournamentMsgState="getMessageStatus('MY_TOURNAMENTS', tournament.enrolled, tournament.active, tournament.inProgress, tournament.lastUserRankingPlace, tournament.tournamentParticipanteStatus)"
                        :tournamentTitle="tournament.name" :tournamentStartDate="new Date(tournament.startTime)"
                        :tournamentEndDate="new Date(tournament.endTime)"
                        :tournamentInfo="[{ icon: 'fa-regular fa-calendar', text: getFormattedDate(new Date(tournament.startTime)) }, { icon: 'fa-regular fa-user', text: `${tournament.participantCount} participants` }, { icon: 'fa-regular fa-trophy', text: `${tournament.awardCount} prizes` }]"
                        :tournamentActive="tournament.active" :tournamentInProgress="tournament.inProgress"
                        :tournamentUserEnrolled="tournament.enrolled" :tournamentId="tournament.id">
                    </TournamentCard>
                </div>
            </div>
            <h2 v-show="!mtFilteredTournaments.length" class="all-tournaments__cards__noTournaments-paragraph">{{
                $t("noEnrolled") }}</h2>
            <div class="slider-controls">
                <button disabled class="prev-btn" @click="scrollContainer('mt', false)">
                    <i class="fa-regular fa-chevron-left"></i>
                </button>
                <button disabled class="next-btn" @click="scrollContainer('mt', true)">
                    <i class="fa-regular fa-chevron-right"></i>
                </button>
            </div>
        </section>
        <v-overlay :dark="false" v-if="showAddTournament">
            <AddTournament :showMessage="showMessage" :hideOverlay="hideOverlay" :setLoading="setLoading">
            </AddTournament>
        </v-overlay>
        <LoadingOverlay style="position: fixed;" :loading="loading"></LoadingOverlay>
        <v-snackbar :color="msgType == 'success' ? 'success' : 'error'" v-model="showMsg">
            {{ msgTxt }}
        </v-snackbar>
    </div>
</template>

<script>
import TournamentCard from '../components/TournamentCard.vue';
import tournament from '../../../repositories/tournament';
import LoadingOverlay from '../../../components/LoadingOverlay.vue';
import { mapMutations } from 'vuex';

import AddTournament from '../components/AddTournament.vue';

export default {
    components: {
        TournamentCard,
        LoadingOverlay,
        AddTournament
    },
    watch: {
        atActiveTab: async function () {
            this.loading = true;
            this.atFilteredTournaments = this.getTournamentsFiltered("all", this.atActiveTab, false);
            setTimeout(() => {
                this.updateSliderControlsStatus(document.querySelector('.tournaments-view .all-tournaments .cards-container-parent'));
            }, 0)
            this.loading = false;
        },
        mtActiveTab: async function () {
            this.loading = true;
            this.mtFilteredTournaments = this.getTournamentsFiltered("not_all", this.mtActiveTab, true);
            setTimeout(() => {
                this.updateSliderControlsStatus(document.querySelector('.tournaments-view .my-tournaments .cards-container-parent'));
            }, 0)
            this.loading = false;
        }
    },
    inject: ['isMobile'],
    data: function () {
        return {
            includeImg: false,
            allTournaments: [],
            publicTournaments: [],
            userTournaments: [],
            atActiveTab: "actives",
            atFilteredTournaments: [],
            mtActiveTab: "actives",
            mtFilteredTournaments: [],
            loading: false,
            showAddTournament: false,
            showMsg: false,
            msgTxt: "",
            msgType: "success"
        }
    },
    computed: {
        tabContrastTextColor() {
            // Get the main green color from Vuetify theme
            const greenColor = this.$vuetify.theme.themes[this.$vuetify.theme.dark ? 'dark' : 'light'].mainGreen;
            let hexColor = greenColor;

            // Remove # if present
            if (hexColor.startsWith('#')) {
                hexColor = hexColor.substring(1);
            }

            // Convert hex to RGB
            const r = parseInt(hexColor.substr(0, 2), 16);
            const g = parseInt(hexColor.substr(2, 2), 16);
            const b = parseInt(hexColor.substr(4, 2), 16);

            // Calculate YIQ contrast ratio
            const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;

            // Return black for light backgrounds, white for dark backgrounds
            return yiq >= 128 ? '#000000' : '#ffffff';
        }
    },
    async mounted() {
        await this.setTournamentArrays();
        this.atFilteredTournaments = this.getTournamentsFiltered("all", "actives", false);
        this.mtFilteredTournaments = this.getTournamentsFiltered("myTournaments", "actives", true);
        if (!this.atFilteredTournaments.length) {
            this.atActiveTab = 'finished'
        }
        this.updateSliderControlsStatus(document.querySelector('.tournaments-view .my-tournaments .cards-container-parent'));
        this.setClubMember(null);

        // Set CSS custom property for tab text color
        this.$nextTick(() => {
            document.documentElement.style.setProperty('--tab-active-text-color', this.tabContrastTextColor);
        });
    },
    methods: {
        ...mapMutations(['setClubMember']),
        getTournamentsFiltered(type, condition, onlyEnrolled) {
            let filteredTournaments = type == "all" ? this.publicTournaments : this.allTournaments;
            filteredTournaments.forEach(t => {
                if (t.tournament) {
                    Object.assign(t, {
                        ...t.tournament,
                        awardCount: t.awardCount,
                        participantCount: t.participantCount,
                    });
                }
            });

            let user_tournaments = this.userTournaments;
            filteredTournaments.forEach(t => {
                let tournament = user_tournaments.find(ut => ut.tournamentId == t.id);
                if (tournament) {
                    let new_t = { ...t, ...tournament }
                    new_t.enrolled = true;
                    Object.assign(t, new_t)
                }
            });

            filteredTournaments = filteredTournaments.filter(ft => {
                if (ft.tournamentVisibility == "PRIVATE") {
                    if (ft.lastUserRankingPlace !== undefined) {
                        return ft;
                    }
                } else if (ft.tournamentVisibility == "PUBLIC") {
                    return ft;
                }
            });

            if (onlyEnrolled) {
                filteredTournaments = filteredTournaments.filter(ft => ft.lastUserRankingPlace !== undefined)
            }

            if (condition == "actives") {
                filteredTournaments = filteredTournaments.filter(t => {
                    let startTime = new Date(t.startTime).getTime();
                    let endTime = new Date(t.endTime).getTime();
                    let now = new Date().getTime();
                    t.inProgress = false;
                    if (startTime < now && now < endTime) {
                        t.inProgress = true;
                        t.active = true;
                    }
                    else if (now < startTime && now < endTime) {
                        t.active = true;
                        t.inProgress = false;
                    }
                    if (t.active)
                        return t;
                })
            } else {
                filteredTournaments = filteredTournaments.filter(t => (new Date(t.endTime) <= new Date()));
            }

            return filteredTournaments;
        },

        async getTournamentsByUser() {
            return (await tournament.getTournamentsByUser(this.$store.state.user.id)).data
        },

        getMessageStatus(type, enrolled, active, inProgress, position, userStatus) {
            let msg = {};
            if (!active) {
                msg.text = this.$t('tournamentStatuses.closed');
                msg.color = "bg-gray";
            }
            switch (type) {
                case "ALL":
                    if (active) {
                        if (enrolled) {
                            msg.text = this.$t('tournamentStatuses.alreadyIn');
                            msg.color = "bg-black";
                        }
                        if (inProgress && !enrolled) {
                            msg.text = this.$t('tournamentStatuses.missing');
                            msg.color = "bg-gray";
                        }
                        if (!inProgress && !enrolled) {
                            msg.text = this.$t('tournamentStatuses.joinNow');
                            msg.color = "bg-black";
                        }
                    }
                    break;
                default:
                    if (!active) {
                        msg.icon = "fa-regular fa-lock";
                    } else {
                        if (inProgress) {
                            msg.text = this.$t('tournamentStatuses.active');
                            msg.icon = "fa-regular fa-calendar-check";
                            msg.color = "swt-success"
                            msg.id = "MTA";
                        }
                        if (!inProgress) {
                            msg.text = this.$t('tournamentStatuses.waiting');
                            msg.icon = "fa-regular fa-clock";
                            msg.id = "WTS";
                        }
                        if (inProgress && userStatus == "PAUSED") {
                            msg.text = this.$t('tournamentStatuses.paused');
                            msg.icon = "fa-regular fa-triangle-exclamation";
                            msg.color = "swt-warning"
                        }
                        if (inProgress && userStatus == "DISQUALIFIED") {
                            msg.text = this.$t('tournamentStatuses.disqualified');
                            msg.icon = "fa-regular fa-circle-exclamation";
                            msg.color = "swt-error"
                        }
                    }
                    if (position <= 3 && position) {
                        msg.text = `${active ? this.$t('tournamentStatuses.positionTexts.youre') : this.$t('tournamentStatuses.positionTexts.youfinished')} ${position}${position == 1 ? this.$t('tournamentStatuses.positionTexts.firstSuffix') : position == 2 ? this.$t('tournamentStatuses.positionTexts.secondSuffix') : this.$t('tournamentStatuses.positionTexts.thirdSuffix')} ${this.$t('tournamentStatuses.positionTexts.place')}`;
                        msg.icon = "fa-regular fa-medal";
                    }
                    break;
            }
            return msg;

        },

        async setTournamentArrays() {
            this.loading = true;
            this.publicTournaments = (await tournament.getPublicTournaments()).data;
            this.allTournaments = (await tournament.getAllTournaments()).data;
            this.userTournaments = await this.getTournamentsByUser();
            this.loading = false;
        },

        scrollContainer(from, right) {
            let container = from == "at" ? document.querySelector(".all-tournaments__cards .cards-container-parent") : document.querySelector(".my-tournaments .cards-container-parent");

            if (window.innerWidth <= 768) {
                container.scrollBy(right ? 463 : -463, 0);
            } else {
                container.scrollBy(right ? 400 : -400, 0);
            }
        },

        getFormattedDate(date) {
            let year = date.getFullYear();
            let month = (1 + date.getMonth()).toString().padStart(2, '0');
            let day = date.getDate().toString().padStart(2, '0');

            return month + '/' + day + '/' + year;
        },

        updateSliderControlsStatus(container) {
            let a = container.scrollLeft;
            let b = container.scrollWidth - container.clientWidth;
            //Scroll percentage (0-1)
            let c = a / b;
            if (c == 0) {
                container.parentElement.querySelector(".prev-btn").setAttribute("disabled", "disabled");
                container.parentElement.querySelector(".next-btn").removeAttribute("disabled");
            }
            else if (c == 1) {
                container.parentElement.querySelector(".next-btn").setAttribute("disabled", "disabled");
                container.parentElement.querySelector(".prev-btn").removeAttribute("disabled");
            } else if (isNaN(c)) {
                container.parentElement.querySelector(".next-btn").setAttribute("disabled", "disabled");
                container.parentElement.querySelector(".prev-btn").setAttribute("disabled", "disabled");
            } else {
                container.parentElement.querySelector(".next-btn").removeAttribute("disabled", "disabled");
                container.parentElement.querySelector(".prev-btn").removeAttribute("disabled", "disabled");
            }
        },

        hideOverlay() {
            this.showAddTournament = false;
        },

        showMessage(type) {
            if (type == 'success') {
                this.msgTxt = this.$t('addTournmanent.successMsg')
                this.msgType = 'success'
            } else {
                this.msgTxt = this.$t('addTournmanent.errorMsg')
                this.msgType = 'error'
            }
            this.showMsg = true;
        },
        setLoading() {
            this.loading = !this.loading;
        }
    }
}
</script>

<style lang="scss">
.theme--dark {
    .tournaments-view {
        .tournaments-heading {
            .tabs {
                background-color: #303740 !important;
            }
        }
    }
}

.tournaments-view {
    display: flex;
    flex-direction: column;

    .all-tournaments__cards__noTournaments-paragraph {
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: "Avenir", sans-serif !important;
        text-align: center;
        height: 320px;
        color: var(--v-mainBlack-base);
        opacity: 0.2;
    }

    .tournaments-view__banner {
        position: relative;
        background: linear-gradient(75deg, rgba(0, 0, 0, 1) 0%, rgba(0, 247, 132, 0.6) 100%);
        background-size: cover;
        background-repeat: no-repeat;
        height: 310px;
        border-radius: 15px;
        display: flex;
        flex-direction: row;
        margin-bottom: 82px;
        overflow: hidden;

        .banner-title {
            display: flex;
            position: absolute;
            top: 0;
            left: 0;
            font-family: "Avenir", sans-serif !important;
            font-weight: bold;

            span {
                font-size: 14px;
                line-height: 1;
                padding-top: 50px;
                padding-left: 50px;
                color: var(--v-white-base) !important;

                .tournaments-word {
                    font-size: 50px;
                    color: var(--v-white-base);
                }
            }
        }

        .banner-text {
            display: flex;
            position: absolute;
            flex-direction: row;
            right: 0;
            bottom: 0;
            padding: 44px 28px;
            padding-right: 110px;
            background: #1B1B1B;
            border-top-left-radius: 15px;
            border-bottom-right-radius: 15px;
            justify-content: space-between;
            align-items: center;
            font-family: "Avenir", sans-serif !important;

            p {
                color: white !important;
                font-size: 14px;
                padding-right: 30px;
                font-weight: normal;

                .special-text {
                    color: var(--v-mainGreen-base);
                    font-size: 20px;
                    font-weight: bold;
                }
            }

            .partner-logo {
                position: absolute;
                right: 26px;
                height: 70px;
            }
        }

        .banner-img {
            margin-left: auto;
            margin-right: auto;

            @media(max-width: 900px) {
                display: none;
            }
        }
    }

    .all-tournaments {
        display: flex;
        flex-direction: column;
        margin-bottom: 125px;
        overflow: visible;
        -ms-overflow-style: none;
        scrollbar-width: none;
        position: relative;

        &::-webkit-scrollbar {
            display: none;
        }

        .tournaments-heading {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 27px;

            .tournaments-heading__items {
                display: flex;
                align-items: center;
                min-width: 600px;


                h6 {
                    font-family: "Avenir", sans-serif;
                    font-size: 32px;
                    font-weight: bold;

                }

                .tabs {
                    display: flex;
                    position: relative;
                    background-color: var(--v-lightGray-base);
                    border-radius: 10px;
                    margin-left: 40px;

                    * {
                        z-index: 2;
                    }

                    input[type="radio"] {
                        &:checked {
                            &+label {
                                color: #000 !important;
                            }
                        }
                    }

                    input[type="radio"] {
                        display: none;
                    }

                    input[id="active-option"] {
                        &:checked {
                            &~.glider {
                                transform: translateX(0);
                            }
                        }
                    }

                    label {
                        i {
                            padding-right: 16px;
                            font-size: 14px;
                        }
                    }

                    input[id="finished-option"] {
                        &:checked {
                            &~.glider {
                                transform: translateX(100%);
                            }
                        }
                    }

                    .tab {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        width: 123px;
                        height: 38px;
                        font-size: 16px;
                        font-weight: normal;
                        color: var(--v-mainBlack-base);
                        border-radius: 10px;
                        cursor: pointer;
                        transition: color 0.15s ease-in;
                        font-family: "Avenir", sans-serif;
                        font-size: 16px;
                    }

                    .glider {
                        position: absolute;
                        display: flex;
                        height: 38px;
                        width: 123px;
                        background-color: var(--v-mainGreen-base);
                        border-radius: 10px;
                        z-index: 1;
                        transition: 0.25s ease-out;
                    }

                }
            }

            .all-tournaments-heading__add-button {
                display: flex;
                align-items: center;
                padding: 10px;
                border-radius: 30px;
                background: transparent;
                border: 1px solid var(--v-mainGreen-base);
                color: var(--v-mainGreen-base);
                font-family: "Avenir", sans-serif;
                font-size: 16px;
                font-weight: normal;
                transition: box-shadow ease-in-out 0.1s;

                i {
                    padding-right: 10px;
                }

                &:hover {
                    box-shadow: 0px 0px 6px 0px rgba(0, 195, 97, 1);
                }
            }
        }


    }

    .my-tournaments {

        margin-bottom: 40px;

        .tournaments-heading {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 27px;

            .tournaments-heading__items {
                display: flex;
                align-items: center;
                min-width: 600px;

                h6 {
                    font-family: "Avenir", sans-serif !important;
                    font-size: 32px;
                    font-weight: bold;
                }

                .tabs {
                    display: flex;
                    position: relative;
                    background-color: var(--v-lightGray-base);
                    border-radius: 10px;
                    margin-left: 40px;

                    * {
                        z-index: 2;
                    }

                    input[type="radio"] {
                        &:checked {
                            &+label {
                                color: #000 !important;
                            }
                        }
                    }

                    input[type="radio"] {
                        display: none;
                    }

                    input[id="active-option-mt"] {
                        &:checked {
                            &~.glider {
                                transform: translateX(0);
                            }
                        }
                    }

                    label {
                        i {
                            padding-right: 16px;
                            font-size: 14px;
                        }
                    }

                    input[id="finished-option-mt"] {
                        &:checked {
                            &~.glider {
                                transform: translateX(100%);
                            }
                        }
                    }

                    .tab {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        width: 123px;
                        height: 38px;
                        font-size: 16px;
                        font-weight: normal;
                        color: var(--v-mainBlack-base);
                        border-radius: 10px;
                        cursor: pointer;
                        transition: color 0.15s ease-in;
                        font-family: "Avenir", sans-serif;
                        font-size: 16px;
                    }

                    .glider {
                        position: absolute;
                        display: flex;
                        height: 38px;
                        width: 123px;
                        background-color: var(--v-mainGreen-base);
                        border-radius: 10px;
                        z-index: 1;
                        transition: 0.25s ease-out;
                    }

                }
            }


        }

    }

    .slider-controls {
        display: flex;
        flex-direction: row;
        width: 100%;
        justify-content: flex-end;

        button {
            display: flex;
            align-items: center;
            justify-content: center;
            border: none;
            outline: 0;
            margin: 5px 10px;
            width: 38px;
            height: 38px;
            background: var(--v-mainGreen-base);
            padding: 0;

            i {
                color: var(--v-mainWhite-base);
            }

            &:disabled {
                background: var(--v-mainBlack-base);
                opacity: 0.1;

                i {
                    color: var(--v-mainWhite-base);
                }
            }
        }
    }

    .cards-container-parent {

        -ms-overflow-style: none;
        scrollbar-width: none;
        overflow: scroll;
        scroll-behavior: smooth;

        &::-webkit-scrollbar {
            display: none;
        }

        .cards-container {
            width: fit-content;
            display: flex;
            justify-content: flex-start;

            .tournament-card {
                margin-right: 50px;
                margin-bottom: 20px;

                @media (max-width: 768px) {
                    width: 89vw;
                    margin-right: 10px;
                    margin-left: 10px;
                }
            }
        }
    }

    @media(max-width: 1000px) {
        .all-tournaments {
            .tournaments-heading {
                margin-top: 40px;

                .all-tournaments-heading__add-button {
                    margin-top: -180px;
                    position: absolute;
                    right: 0;
                }

                .tournaments-heading__items {
                    flex-direction: column;
                    width: 100%;
                    align-items: center;
                    min-width: unset;

                    .tabs {
                        margin-left: unset;
                    }

                    h6 {
                        margin-bottom: 20px;
                    }
                }

            }
        }

        .my-tournaments {
            .tournaments-heading {
                .tournaments-heading__items {
                    flex-direction: column;
                    width: 100%;
                    align-items: center;
                    min-width: unset;

                    .tabs {
                        margin-left: unset;
                    }

                    h6 {
                        margin-bottom: 20px;
                    }
                }
            }
        }
    }

    @media(max-width:768px) {
        .tournaments-view__banner {
            display: none;
        }

        .all-tournaments {
            margin-top: 40px;

            .all-tournaments__cards {
                .cards-container-parent {
                    .cards-container {
                        .tournament-card {
                            margin-right: 10px;
                            margin-left: 10px;
                        }
                    }
                }
            }

            .slider-controls {
                justify-content: center
            }
        }

        .my-tournaments {
            .slider-controls {
                justify-content: center
            }
        }
    }

    .v-tabs {
        border-radius: 8px;
        overflow: hidden;

        ::v-deep {

            // Remove bottom bar
            .v-tabs-bar {
                border-bottom: none !important;

                &::before {
                    display: none !important;
                }
            }

            // Remove slider
            .v-tabs-slider {
                display: none !important;
            }

            .v-slide-group__wrapper {
                background-color: var(--v-lightGray-base);
                border-radius: 8px;
                flex: unset;
                margin-left: auto;
            }

            .v-tab {
                text-transform: none;
                font-family: 'Avenir', sans-serif;
                font-size: 14px;
                color: var(--v-mainBlack-base) !important;
                min-height: 32px !important;
                margin: 0px;
                border-radius: 8px;
                padding: 0 20px !important;
                text-decoration: none;

                &--active {
                    background-color: var(--v-mainBtnBackground-base);
                    color: var(--v-darkGreen-base) !important;
                }

                .v-icon {
                    color: inherit !important;
                }

                &.v-tab--active {
                    background-color: var(--v-mainGreen-base) !important;
                    color: var(--v-darkGreen-base) !important;
                    border-radius: 8px;
                    border-bottom: none !important;
                }

                &::before,
                &::after {
                    opacity: 0 !important;
                    background-color: transparent !important;
                    display: none !important;
                }
            }
        }
    }
}
</style>